
import HeroBannerGeneral from "@soenergy/frontend-library/src/components/HeroBannerGeneral"
import ContentBlockList from "@soenergy/frontend-library/src/components/ContentBlockList"

export default {
  name: `LandingPage`,
  components: {
    HeroBannerGeneral,
    ContentBlockList
  },
  props: {
    content: {
      required: true,
      type: Object
    }
  },
  computed: {
    hero() {
      return this.content.hero?.[0]
    }
  }
}
